<!-- 基本信息-预警信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header  flex flexJc-sb">
        <div class="head-title borderB">
          <div class="text">受监护人员-监测记录</div>
          <div style="margin-top: 10px; width: 100%;">
            <div class="form-data group">
              <span>上传时间：</span>
              <el-date-picker size="mini" v-model="SearchForm.createTime" type="date" placeholder="选择日期"></el-date-picker>
            </div>
            <div class="form-data group" style="padding-left: 10px;">
              <span>设备名称：</span>
              <el-select v-model="SearchForm.xm" filterable placeholder="请选择" clearable>
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="form-data group" style="padding-left: 10px;">
              <el-button size="mini" @click="goSearch" type="primary">搜索</el-button>
            </div>
          </div>
        </div>
        <el-button size="mini" @click="goBack" icon="el-icon-back">返回</el-button>
      </div>
      <div style="width: 100%; display: flex; margin-top: 60px;">
        <div class="dcontent" style="width: 50%;">
          <el-table @row-click="changeRow"
            :header-cell-style="{ background: '#f5f5f5' }"
            :data="logList.list"
            style="width: 100%">
            <!-- <el-table-column prop="id" label="#" min-width="1"> </el-table-column> -->
            <el-table-column prop="createTime" label="上传时间" min-width="5">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | filterTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="5"> </el-table-column>
            <el-table-column prop="deviceCode" label="设备代码" min-width="5"> </el-table-column>
          </el-table>
          <div class="Pagination flex">
            <div class="text">
              <span>共{{ logList.total }}条记录，</span>
              <span class="pageNum">{{ logList.pageNum }}</span>
              <span>/{{ logList.pages }}页</span>
            </div>
            <el-pagination
              v-if="logList !== ''"
              @current-change="handleCurrentChange"
              :current-page.sync="logList.pageNum"
              :page-size="logList.pageSize"
              layout="prev, pager, next, jumper"
              :total="logList.total">
            </el-pagination>
          </div>
        </div>
        <div style="width: 45%;margin-left: 20px;">
          <el-input v-model="logItem.content" :readonly="true" type="textarea" :rows="30" placeholder="" style="width: 100%;"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetAlertPersonLogList } from '@/api/alertManage'
export default {
  name: '',
  props: [''],
  data() {
    return {
      logList: [], // 列表
      routeData: '', // 页面传参
      logItem: {},
      typeOptions: [
        {label: '心率', value: 0},
        {label: '血压', value: 1},
        {label: '紧急救援', value: 2},
        {label: '睡眠雷达', value: 3},
        {label: '健康一体', value: 4},
      ],
      pages: {
        page: 1, // 页数
        size: 50,
      },
      SearchForm: {
        createTime: null,
        xm: null,
      },
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    if (this.$route.query.info !== undefined) {
      this.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routeData)
      this.GetAlertPersonLogList()
    }
  },

  methods: {
    // 刷新
    goSearch() {
      this.pages.page = 1;
      this.GetAlertPersonLogList();
    },
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetAlertPersonLogList()
    },
    // 接口
    // 获取预警的详细信息
    GetAlertPersonLogList() {let doTimeLong = 0;
      let createTimeLong = 0;
      if(this.SearchForm.createTime) {
        createTimeLong = this.SearchForm.createTime.getTime();
      }
      apiGetAlertPersonLogList({
        personId: this.routeData.id,
        xm: this.SearchForm.xm,
        createTimeLong: createTimeLong,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.logList = res.data
        }
      })
    },
    changeRow(row, column, event) {
      console.log(row);
      this.logItem = row;
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 50px;
    .text {
      text-align: left;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 172px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 192px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
